module.exports = __webpack_public_path__ + "46ede7f0b260605bcec35c4b99129f19.png";